import { render, staticRenderFns } from "./CommissionTab.vue?vue&type=template&id=1fdc6dac&scoped=true"
import script from "./CommissionTab.vue?vue&type=script&lang=js"
export * from "./CommissionTab.vue?vue&type=script&lang=js"
import style0 from "./CommissionTab.vue?vue&type=style&index=0&id=1fdc6dac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdc6dac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fdc6dac')) {
      api.createRecord('1fdc6dac', component.options)
    } else {
      api.reload('1fdc6dac', component.options)
    }
    module.hot.accept("./CommissionTab.vue?vue&type=template&id=1fdc6dac&scoped=true", function () {
      api.rerender('1fdc6dac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P2_Page/Invite/components/CommissionTab.vue"
export default component.exports